import { GUIDE_RAW_FILES } from '@/generated/guidesRaw';
import { parseFrontmatter, type GuideFrontmatter } from '@/lib/markdown';

export type Guide = GuideFrontmatter & {
  body: string;
};

function loadGuides(): Guide[] {
  return GUIDE_RAW_FILES.map(({ file, raw }) => {
    const { meta, body } = parseFrontmatter(raw);
    const fileSlug = file.replace(/\.md$/, '');
    if (fileSlug !== meta.slug) {
      throw new Error(
        `Guide slug mismatch: file ${fileSlug} vs frontmatter ${meta.slug}`,
      );
    }
    return { ...meta, body };
  }).sort((a, b) =>
    a.title.localeCompare(b.title, undefined, { sensitivity: 'base' }),
  );
}

export const guides: Guide[] = loadGuides();

export function getGuideBySlug(slug: string): Guide | undefined {
  return guides.find((g) => g.slug === slug);
}
